<app-modal class="plants-create-modal" [isLoading]="isLoading">
    <ng-container modal-header>
        <h5 class="modal-title"
            *ngIf="!isEditMode; else editTitle">
            {{ 'admin.plants.create-modal.title' | translate }}</h5>
        <ng-template #editTitle>
            <h5 class="modal-title">{{ 'admin.plants.update-modal.title' | translate }}</h5>
        </ng-template>
    </ng-container>
    <ng-container modal-body>
        <form class="picklist-form"
              [formGroup]="form">
            <div class="form-group row">
                <app-input formControlName="name"
                           [formControl]="form.controls.name"
                           [showErrors]="showValidations"
                           placeholder="{{'admin.plants.create-modal.name-input.placeholder' | translate }}"
                           label="{{'admin.plants.create-modal.name-input.label' | translate}}">
                </app-input>
                <app-textarea formControlName="description"
                           [formControl]="form.controls.description"
                           [showErrors]="showValidations"
                           placeholder="{{'admin.plants.create-modal.description-input.placeholder' | translate }}"
                           label="{{'admin.plants.create-modal.description-input.label' | translate}}">
                </app-textarea>
                <div class="col s12">
                    <app-input formControlName="documentsLocation"
                               label="{{'admin.plants.create-modal.documentsLocation-input.label' | translate}}"
                               [formControl]="form.controls.documentsLocation"
                               [showErrors]="showValidations"
                               labelAlign="top"
                               tooltipText="{{'admin.plants.create-modal.documentsLocation-input.tooltip' | translate}}"
                               placeholder="{{'admin.plants.create-modal.documentsLocation-input.placeholder' | translate }}">
                    </app-input>
                </div>
            </div>
            <div class="row plant-row">
                <div class="col s12">
                    <app-picklist [source]="lines"
                                  [(target)]="plant.lines"
                                  sourceHeader="{{'admin.plants.create-modal.pick-list.leftHeader' | translate}}"
                                  targetHeader="{{'admin.plants.create-modal.pick-list.rightHeader' | translate}}"
                                  infoLabel="{{'admin.plants.create-modal.alert.message' | translate}}"
                                  (selectionChange)="onPlantLinesSelectionChange($event)"></app-picklist>
                </div>
            </div>
        </form>
    </ng-container>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    class="waves-effect btn-flat"
                    [disabled]="isLoading"
                    (click)="modal.close()">{{ 'generic.buttons.close' | translate }}
        </app-button>
        <div class="mutators">
            <app-button
                type="primary"
                *ngIf="!isEditMode && shouldRenderModifiers()"
                [disabled]="isLoading"
                (clicked)="createPlant()">
                {{ 'admin.plants.create-modal.button.create'| translate }}
            </app-button>
            <app-button type="warning"
                        *ngIf="isEditMode && shouldRenderModifiers()"
                        [disabled]="isLoading"
                        (click)="updatePlant()">
                {{ 'admin.plants.create-modal.button.update'| translate }}
            </app-button>
            <app-button type="danger"
                        *ngIf="isEditMode && shouldRenderModifiers()"
                        [class.disabled]="isPlantInUse()"
                        [disabled]="isLoading"
                        (click)="deletePlant()">
                {{ 'admin.plants.create-modal.button.delete' | translate }}
            </app-button>
        </div>
    </div>
</app-modal>
